<template>
  <div class="large_main">
    <div class="top_title">
      <div class="title_text">电梯物联网管理平台</div>
      <div class="top_city">湖北省</div>
      <div class="top_info">
        <div class="tabs_box">
          <button
            type="button"
            :class="current == index ? 'tab_item active' : 'tab_item'"
            v-for="(item, index) in tabs"
            :key="index"
            @click="tabsChange(index)"
          >
            {{ item }}
          </button>
        </div>
        <div class="time_box">
          <div class="time">{{ time }}</div>
          <button type="button" class="admin" @click="goAdmin">
            <img class="admin_icon" src="@/assets/image/admin_icon.png" alt="" />
            管理后台
          </button>
        </div>
      </div>
    </div>
    <div class="large_content">
      <DataCenter v-if="current == 0" ref="dataCenter" />
      <MonitorCenter v-if="current == 1" ref="monitorCenter" />
    </div>
    <div class="large_bottom"></div>
  </div>
</template>

<script>
import DataCenter from "./dataCenter/index.vue";
import MonitorCenter from "./monitorCenter/index.vue";
export default {
  name: "ElevatorLargeIndex",
  components: {
    DataCenter,
    MonitorCenter,
  },
  data() {
    return {
      tabs: ["数据中心", "监控中心"],
      current: 0,
      time: "",
      timeTimer: null,
    };
  },
  mounted() {
    this.getTime();
  },
  beforeDestroy() {
    if (this.timeTimer) {
      clearInterval(this.timeTimer);
    }
  },

  methods: {
    goAdmin() {
      window.open("https://lift.yqdiot.cn/index");
    },
    tabsChange(index) {
      this.current = index;
    },
    formatDate(timestamp) {
      const date = new Date(timestamp);
      const localeFormattedDate = date.toLocaleString("zh-CN");
      return localeFormattedDate;
    },
    getTime() {
      this.getCurrentDateTime();
      this.timeTimer = setInterval(() => {
        this.getCurrentDateTime();
      }, 1000);
    },
    getCurrentDateTime() {
      let now = new Date();
      let year = now.getFullYear();
      let month = (now.getMonth() + 1).toString().padStart(2, "0");
      let day = now.getDate().toString().padStart(2, "0");
      let hours = now.getHours().toString().padStart(2, "0");
      let minutes = now.getMinutes().toString().padStart(2, "0");
      let seconds = now.getSeconds().toString().padStart(2, "0");
      let weekDays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      let weekDay = weekDays[now.getDay()];
      this.time = `${year}.${month}.${day} ${hours}:${minutes}:${seconds} ${weekDay}`;
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/styles/viewport.scss";

.large_main {
  position: relative;
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
  background: #031321 url("@/assets/image/big_bg.png") center / cover no-repeat;
  padding: 0 vw(20);
  .top_title {
    background: url("@/assets/image/large_top_bg.png") no-repeat center;
    background-size: 100% 100%;
    width: 100%;
    height: vh(90);
    position: relative;
    .title_text {
      width: 100%;
      text-align: center;
      padding-top: vh(6);
      font-family: YouSheBiaoTiHei;
      font-weight: 400;
      font-size: vw(40);
      color: #fff;
      letter-spacing: vw(4);
    }
    .top_city {
      background: url("@/assets/image/city_bg.png") no-repeat center;
      background-size: 100% 100%;
      width: vw(100);
      height: vh(34);
      text-align: center;
      line-height: vh(34);
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 700;
      font-size: vw(16);
      color: #fff;
      position: absolute;
      margin: auto;
      right: 24%;
      top: vh(10);
    }
    .top_info {
      position: absolute;
      margin: auto;
      bottom: 0;
      left: 0;
      right: 0;
      height: vh(40);
      display: flex;
      align-items: center;
      justify-content: space-between;
      .tabs_box {
        margin-left: vw(60);
        display: flex;
        height: vh(40);
        .tab_item {
          height: 100%;
          width: vw(160);
          border: 0;
          padding: 0;
          font: inherit;
          line-height: vh(40);
          cursor: pointer;
          text-align: center;
          margin-right: vw(40);
          background: url("@/assets/image/tab_bg.png") no-repeat center;
          background-size: 100% 100%;
          font-family: YouSheBiaoTiHei;
          font-weight: 400;
          font-size: vw(26);
          color: #7fa1b3;

          &.active {
            background: url("@/assets/image/tab_bg_a.png") no-repeat center;
            background-size: 100% 100%;
            color: #fff;
          }

          &:focus-visible {
            outline: 2px solid #fff;
            outline-offset: 2px;
          }
        }
      }
    }
    .time_box {
      display: flex;
      margin-right: vw(40);

      .time {
        font-weight: 700;
        font-size: vw(18);
        color: #fff;
        margin-right: vw(30);
      }

      .admin {
        width: vw(100);
        height: vh(30);
        box-sizing: border-box;
        border: 1px solid #78cbff;
        padding: 0;
        font: inherit;
        background: rgba(94, 187, 253, 0.2);
        border-radius: 5px;
        font-weight: 400;
        font-size: vw(14);
        color: #82cfff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        line-height: vh(14);
        .admin_icon {
          width: vw(14);
          height: vw(14);
          margin-right: vw(6);
        }

        &:focus-visible {
          outline: 2px solid #fff;
          outline-offset: 2px;
        }
      }
    }
  }

  .large_content {
    // page_main keeps a small top gutter; include it in the available height
    // so the bottom frame remains flush with the viewport edge.
    height: calc(100% - vh(144));
  }

  .large_bottom {
    background: url("@/assets/image/large_bottom_bg.png") no-repeat center;
    background-size: 100% 100%;
    width: 100%;
    height: vh(44);
  }
}
</style>
